/**
 * @generated SignedSource<<159fe8f8eb68ab1a2542a38641b6f4cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutPixAutomaticInfo_subscription$data = {
  readonly pixRecurringCheckoutOptions: {
    readonly comment: string | null | undefined;
    readonly dateEnd: string | null | undefined;
    readonly dateStart: string | null | undefined;
    readonly frequency: string | null | undefined;
    readonly installmentCount: number | null | undefined;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "PaymentCheckoutPixAutomaticInfo_subscription";
};
export type PaymentCheckoutPixAutomaticInfo_subscription$key = {
  readonly " $data"?: PaymentCheckoutPixAutomaticInfo_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutPixAutomaticInfo_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutPixAutomaticInfo_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PixRecuringCheckoutOptions",
      "kind": "LinkedField",
      "name": "pixRecurringCheckoutOptions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frequency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "comment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "installmentCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateEnd",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "ca1c705f0275cf18043a81a8831a5a64";

export default node;
